import compose from 'recompose/compose';
import formatPrismicData from '../../hocs/formatPrismicData';
import OffersList from './OffersList';
import mapProps from 'recompose/mapProps';

const enhance = compose(
  formatPrismicData,
  mapProps(props => ({
    ...props,
    items: props.items.map(item => item.offerDocument),
  }))
);

export default enhance(OffersList);



// WEBPACK FOOTER //
// ./src/client/js/view/components/OffersList/index.js